export const getAnounces = async ({
  dispatchAPI,
  user,
  setAnounces,
  message,
  setReservations,
  setIsLoading
}) => {
  try {
    const { data: pensionerData } = await dispatchAPI('GET', {
      url: `/pensioners?user=${user._id}`
    });

    // No pensioner record for this account: nothing to list, and no page bug
    // reported as a network error.
    const [pensioner] = pensionerData || [];
    if (!pensioner) {
      setReservations([]);
      setAnounces([]);
      return;
    }

    const { data: reservationsData } = await dispatchAPI('GET', {
      url: `/reservations?pensioner=${pensioner._id}`
    });

    const { data } = await dispatchAPI('GET', {
      url: '/anounces/form?filter={"$or":[{"status":"PUBLISHED"}, {"status":"SAVE"}]}&available=true&populate=supervision,supervision.petsitting_address'
    });

    setReservations(reservationsData);
    setAnounces(data);
  } catch (e) {
    message(e);
  } finally {
    setIsLoading(false);
  }
};
